import type { DiseasePayload } from "@/lib/diseases-api";
import type { DiseaseFormValues } from "./diseaseFormSchema";

export const toDiseasePayload = (
  values: DiseaseFormValues
): DiseasePayload => ({
  long_name: values.long_name.trim(),
  short_name: values.short_name.trim(),
  other_names: values.other_names?.trim() || "",
  display_name: values.display_name?.trim() || "",
  icd10_code: values.icd10_code?.trim() || "",
  widely_prevalent: values.widely_prevalent,
  family_linked: values.family_linked,
  is_featured: values.is_featured,
});

export const diseaseInitial = (name?: string | null) =>
  name?.trim()?.[0]?.toUpperCase() || "D";

export const diseaseDisplayName = (disease: {
  display_name?: string | null;
  long_name?: string | null;
}) => disease.display_name || disease.long_name || "Disease";
